
export const makeSelectOptions = (data) => {
    const ex = data?.map((item) => ({
        label: item?.name,
        value: item?.id,
    }))
    return ex;
  };